export const BABY_GROWTH_ACTION = {
  SUBMIT: 'SUBMIT',
  UPDATE_CONTENT: 'UPDATE_CONTENT',
  UPDATE_RESULT: 'UPDATE_RESULT',
  UPDATE_RESULT_BASED_ON_RISK_LEVEL: 'UPDATE_RESULT_BASED_ON_RISK_LEVEL',
  RE_CALCULATE: 'RE_CALCULATE',
  UPDATE_BABY_LIST: 'UPDATE_BABY_LIST',
  IS_NEW_BABY: 'IS_NEW_BABY',
  CURRENT_BABY: 'CURRENT_BABY',
}
